import { loadConsentManagerBaloiseSwitzerland } from '@baloise/web-app-utils';
import { BalGoogleTagManager } from '@baloise/web-app-google-utils';

// for some reason typescript doesn't recognize dataLayer as part of the Window interface
declare global {
  interface Window {
    dataLayer: any;
  }
}

export function useGoogleAnalytics() {
  let gtm: BalGoogleTagManager | undefined;

  function init() {
    if (!gtm) {
      gtm = new BalGoogleTagManager();
      gtm.load({
        apiKey: 'GTM-T6839NX',
        applicationName: 'construction-insurance',
      });
    }
  }

  function initIntegrations() {
    void loadConsentManagerBaloiseSwitzerland();
  }

  return {
    gtm,
    init,
    initIntegrations,
  };
}

const googleAnalyticsService = useGoogleAnalytics();
export default googleAnalyticsService;
